/** Public identities only: safe for the edge router and initial browser entry. */
export const SCHEMATIC_CATEGORIES = [
  { id: "boat", title: "Boat", heading: "Boat wiring examples", summary: "Keep the bilge pump powered, retrofit a LiFePO4 house battery, or plan solar and separate-bank charging.", tint: "var(--lp-sky)" },
  { id: "van", title: "Campervan", heading: "Campervan wiring examples", summary: "Plan roof solar, alternator charging, shore charging and the DC side of an inverter.", tint: "var(--lp-sun)" },
  { id: "off-grid-cabin", title: "Off-grid cabin", heading: "Off-grid cabin wiring examples", summary: "Start with solar and lights, then explore battery monitoring, load protection and inverter power.", tint: "var(--lp-mint)" },
] as const;

export const SCHEMATIC_CATEGORY_ROUTES = [
  { id: "examples-boat", kind: "example", path: "/examples/boat/", category: "boat" },
  { id: "examples-van", kind: "example", path: "/examples/van/", category: "van" },
  { id: "examples-off-grid-cabin", kind: "example", path: "/examples/off-grid-cabin/", category: "off-grid-cabin" },
] as const;

export const SCHEMATIC_EXAMPLE_ROUTES = [
  { id: "boat-always-on-bilge", kind: "example", path: "/examples/boat/always-on-bilge/" },
  { id: "boat-lifepo4-retrofit", kind: "example", path: "/examples/boat/lifepo4-retrofit/" },
  { id: "boat-solar-house-bank", kind: "example", path: "/examples/boat/solar-house-bank/" },
  { id: "boat-trolling-motor-bank", kind: "example", path: "/examples/boat/trolling-motor-bank/" },
  { id: "boat-dockside-two-bank-charging", kind: "example", path: "/examples/boat/dockside-two-bank-charging/" },
  { id: "boat-dual-battery-selector", kind: "example", path: "/examples/boat/dual-battery-selector/" },
  { id: "van-orion-alternator-charging", kind: "example", path: "/examples/van/orion-alternator-charging/" },
  { id: "van-redarc-solar-and-alternator", kind: "example", path: "/examples/van/redarc-solar-and-alternator/" },
  { id: "van-roof-solar-and-dc-loads", kind: "example", path: "/examples/van/roof-solar-and-dc-loads/" },
  { id: "van-shore-charging-with-monitor", kind: "example", path: "/examples/van/shore-charging-with-monitor/" },
  { id: "van-inverter-dc-supply", kind: "example", path: "/examples/van/inverter-dc-supply/" },
  { id: "off-grid-cabin-solar-lighting", kind: "example", path: "/examples/off-grid-cabin/solar-lighting/" },
  { id: "off-grid-cabin-battery-monitor", kind: "example", path: "/examples/off-grid-cabin/battery-monitor/" },
  { id: "off-grid-cabin-protected-dc-loads", kind: "example", path: "/examples/off-grid-cabin/protected-dc-loads/" },
  { id: "off-grid-cabin-two-solar-arrays", kind: "example", path: "/examples/off-grid-cabin/two-solar-arrays/" },
  { id: "off-grid-cabin-inverter-supply", kind: "example", path: "/examples/off-grid-cabin/inverter-supply/" },
] as const;

export type SchematicExampleId = (typeof SCHEMATIC_EXAMPLE_ROUTES)[number]["id"];
export type SchematicCategoryPageId = (typeof SCHEMATIC_CATEGORY_ROUTES)[number]["id"];
export function schematicExamplePath(id: string): string {
  const route = SCHEMATIC_EXAMPLE_ROUTES.find(route => route.id === id);
  if (!route) throw new Error(`Unknown schematic: ${id}`);
  return route.path;
}
